module.exports = __webpack_public_path__ + "static/media/diana.f7c5d45c.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/diana.JPG
// module id = 675
// module chunks = 0